import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

const DoctorScheduleModal = ({ isOpen, onClose, doctor }) => {
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';
        };
    }, [isOpen]);

    if (!isOpen || !doctor) return null;

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) onClose();
    };

    const schedule = [
        { day: "Senin", hours: "08:00 - 12:00" },
        { day: "Selasa", hours: "08:00 - 12:00" },
        { day: "Rabu", hours: "08:00 - 12:00" },
        { day: "Kamis", hours: "08:00 - 12:00" },
        { day: "Jumat", hours: "08:00 - 12:00" },
    ];

    return ReactDOM.createPortal(
        <div
            className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm transition-opacity animate-in fade-in duration-300"
            onClick={handleBackdropClick}
            style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0 }}
        >
            <div className="bg-white w-full max-w-[420px] rounded-[32px] shadow-2xl relative overflow-hidden animate-in zoom-in-95 duration-300">
                {/* Close Button */}
                <button
                    onClick={onClose}
                    className="absolute top-6 right-6 text-gray-400 hover:text-cyan-500 transition-colors z-10"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                </button>

                <div className="p-8 pt-12 flex flex-col items-center">
                    {/* Doctor Info */}
                    <div className="w-32 h-32 rounded-full overflow-hidden mb-6 border-4 border-gray-50 shadow-sm">
                        <img
                            src={doctor.image || "https://i.pravatar.cc/150"}
                            alt={doctor.name}
                            className="w-full h-full object-cover"
                        />
                    </div>

                    <h2 className="text-2xl font-bold text-gray-900 mb-1">{doctor.name}</h2>
                    <p className="text-gray-500 text-sm mb-4">{doctor.specialization || "Saraf"}</p>

                    <div className="flex items-center gap-2 text-[#06B6D4] font-medium mb-8">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                        <span className="text-lg">(021) 1234 5678</span>
                    </div>

                    {/* Divider Title */}
                    <div className="w-full flex items-center gap-4 mb-6">
                        <div className="flex-1 h-[1px] bg-gray-100"></div>
                        <span className="text-gray-500 font-bold text-lg">Jadwal Praktik</span>
                        <div className="flex-1 h-[1px] bg-gray-100"></div>
                    </div>

                    {/* Schedule List */}
                    <div className="w-full space-y-5">
                        {schedule.map((item, index) => (
                            <div key={index} className="flex justify-between items-center group">
                                <span className="text-gray-500 text-lg">{item.day}</span>
                                <span className="text-gray-400 font-medium text-lg">{item.hours}</span>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Decorative bottom padding */}
                <div className="h-8"></div>
            </div>
        </div>,
        document.body
    );
};

export default DoctorScheduleModal;
